import React from 'react';
import { IfmsRoute } from '../../../config/types';

export const AeMawbView = React.lazy(() => import('../mawb/AeMawbView'));
export const AeHawbView = React.lazy(() => import('../hawb/AeHawbView'));
const AeEawbView = React.lazy(() => import('../eawb/AeEawbView'));
const AeQuotationView = React.lazy(() => import("../quotation/AeQuotationView"));
const AeMawbBillingsView = React.lazy(() => import('../mawb/AeMBillingsView'));
const AeHawbBillingsView = React.lazy(() => import('../hawb/AeHBillingsView'));
const CorrectionNoticeView = React.lazy(() => import('../../reports/CorrectionNoticeView')); //
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView')); //
const AemPrintMawbView = React.lazy(() => import('../../reports/PrintView'));
const AemBatchPrintView = React.lazy(() => import('../mawb/more/BatchPrintView'));
const AgentDocumentView = React.lazy(() => import('../../reports/AgentDocumentPackageView'));
const CargoManifestView = React.lazy(() => import('../../reports/CargoManifestView'));
const AirLabelView = React.lazy(() => import('../../reports/AirLabelView'));
const PouchAirLabelView = React.lazy(() => import('../mawb/more/PouchAirLabelView'));
const IACCertificateKnownView = React.lazy(() => import('../mawb/more/IACCertificateKnownView'));
const IACCertificateUnknownView = React.lazy(() => import('../mawb/more/IACCertificateUnknownView'));
const CertificationOriginView = React.lazy(() => import('../../reports/CertificateOfOriginView'));
const MemoListView = React.lazy(() => import('../../reports/MemoListView')); //
const ShippingAdviceView = React.lazy(() => import('../../reports/ShippingAdviceView'));
const TransferManifestView = React.lazy(() => import('../mawb/more/TransferManifestView'));
const SendBLtoPatnerView = React.lazy(() => import('../../reports/SendBlView'));
const DocumentView = React.lazy(() => import('../../reports/DocumentPackageView'));
const CommercialInvoiceView = React.lazy(() => import('../../reports/CommercialInvoiceView'));
const AemPrintHawbView = React.lazy(() => import('../../reports/PrintView'));
const BankDraftView = React.lazy(() => import('../../reports/BankDraftView'));
const PackageLabelView = React.lazy(() => import('../../reports/PackageLabelView')); //
const PackingListView = React.lazy(() => import('../../reports/CommercialInvoiceView'));
const StraightBlView = React.lazy(() => import('../../reports/StraightBlView')); //
const FolderLabelView = React.lazy(() => import('../../reports/FolderLabelView'));
const ProfitAndVolumeSummaryView = React.lazy(() => import('../../common/reports/ProfitAndVolumeSummaryView'));
const DownloadView = React.lazy(() => import('../../common/DownloadView'));

const routes: Array<IfmsRoute> = [
  { path: '/airExport/mawb/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: AeMawbView },
  { path: '/airExport/hawb/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: AeHawbView },
  { path: '/airExport/eawb', component: AeEawbView },
  { path: '/airExport/quotation/:mode/:id?', component: AeQuotationView },
  { path: '/airExport/viewBillings/mawb/:id?', component: AeMawbBillingsView },
  { path: '/airExport/viewBillings/hawb/:id?', component: AeHawbBillingsView },

  //AEM MoreMenu
  { path: '/airExport/correctionNotice', component: CorrectionNoticeView },
  { path: '/airExport/pickupDelivery', component: PickupDeliveryView },
  { path: '/airExport/aemPrintMawb', component: AemPrintMawbView },
  { path: '/airExport/aemBatchPrint', component: AemBatchPrintView },
  { path: '/airExport/agentDocument', component: AgentDocumentView },
  { path: '/airExport/cargoManifest', component: CargoManifestView },
  { path: '/airExport/airLabel', component: AirLabelView },
  { path: '/airExport/pouchAirLabel', component: PouchAirLabelView },
  { path: '/airExport/iacCertificateKnown', component: IACCertificateKnownView },
  { path: '/airExport/iacCertificateUnknown', component: IACCertificateUnknownView },
  { path: '/airExport/certificationOrigin', component: CertificationOriginView },
  { path: '/airExport/memoList', component: MemoListView },
  { path: '/airExport/shippingAdvice', component: ShippingAdviceView },
  { path: '/airExport/transferManifest', component: TransferManifestView },
  { path: '/airExport/sendBLtoPatner', component: SendBLtoPatnerView },
  { path: '/airExport/estProfit', component: ProfitAndVolumeSummaryView },
  { path: '/airExport/folderLabel', component: FolderLabelView },

  //AEH MoreMenu
  { path: '/airExport/correctionNotice', component: CorrectionNoticeView },
  { path: '/airExport/pickupDelivery', component: PickupDeliveryView },
  { path: '/airExport/aemPrintHawb', component: AemPrintHawbView },
  { path: '/airExport/airLabel', component: AirLabelView },
  { path: '/airExport/bankDraft', component: BankDraftView },
  { path: '/airExport/certificationOrigin', component: CertificationOriginView },
  { path: '/airExport/documentPackage', component: DocumentView },
  { path: '/airExport/commercialInvoice', component: CommercialInvoiceView },
  { path: '/airExport/memoList', component: MemoListView },
  { path: '/airExport/memoCustomerList', component: MemoListView },
  { path: '/airExport/packageLabel', component: PackageLabelView },
  { path: '/airExport/packingList', component: PackingListView },
  { path: '/airExport/shippingAdvice', component: ShippingAdviceView },
  { path: '/airExport/straightBl', component: StraightBlView },

  //Download
  { path: '/airExport/download/:jobName?/:id?', component: DownloadView },
];
export default routes;
